import React from 'react';
import { TwoSidedScoreCard } from './TwoSidedScoreCard';
import { ScoreCard } from './ScoreCard';
import { round2 } from '../../lib/format';

export const FourFactorsSummary = ({ totals }) => {
  const teamCalculated = totals.team.calculated;
  const oppCalculated = totals.opponent.calculated;

  const fourFactorsFields = ['efg', 'orr', 'ftr', 'tov'];

  const possessions = totals.total_possessions;
  const minutes = totals.total_minutes;

  const statCards = fourFactorsFields.map(stat => {
    const teamStat = teamCalculated[stat];
    const oppStat = oppCalculated[stat];
    const netValue = stat === 'tov' ? oppStat - teamStat : teamStat - oppStat;
    return (
      <div className="s-lineup-explorer__score" key={stat}>
        <TwoSidedScoreCard
          title={stat}
          value={teamStat}
          oppValue={oppStat}
          netValue={netValue}
        />
      </div>
    );
  });

  return (
    <div className="s-lineup-explorer__data-container">
      <h3 className="s-lineup-explorer__metrics-header">
        Four Factors - All Lineups
      </h3>
      <div className="s-lineup-explorer__scores-container">
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="Minutes"
            value={Math.ceil(minutes)}
            color="#417505"
          />
        </div>
        <div className="s-lineup-explorer__score">
          <ScoreCard
            title="Possessions"
            value={round2(possessions)}
            color="#417505"
          />
        </div>
      </div>
      <div className="s-lineup-explorer__scores-container">{statCards}</div>
    </div>
  );
};
